import { render } from "./RoomController.vue?vue&type=template&id=7bee81a4&ts=true"
import script from "./RoomController.vue?vue&type=script&lang=ts"
export * from "./RoomController.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__